export default __webpack_public_path__ + "static/media/image-01.9ec0948a.jpg";